module.exports = {"title":"Login","emailPH":"Email","pwdPH":"Password","submitTxt":"Login","busyTxt":"Please Wait...","errMsg":"The login failed - please check your inputs","registerHint1":"Don't have an account yet ?","registerHint2":"Register here"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/login/en.json
// module id = pc4X
// module chunks = 1